//Silence is golden
import './app.scss';
